import React from 'react';
import './Skeletons.css';

const FilterSkeleton = () => {
    return (
        <div className="filter-skeleton-wrapper hidden lg:block">
            {/* 1st item - Rectangle 160361 */}
            <div className="filter-skeleton-item-1 shimmer-bg"></div>

            {/* 2nd item container - Group 2087325237 */}
            {[1, 2, 3, 4, 5, 6].map((i) => (
                <div key={i} className="filter-skeleton-group">
                    {/* Rectangle 160362 */}
                    <div className="filter-skeleton-rect-1 shimmer-bg"></div>

                    <div className="filter-skeleton-row">
                        {/* Rectangle 160363 */}
                        <div className="filter-skeleton-rect-small shimmer-bg"></div>
                        {/* Rectangle 160364 */}
                        <div className="filter-skeleton-rect-small shimmer-bg"></div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default FilterSkeleton;
